import { FC, useState, ChangeEvent } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Divider, FormControlLabel, ListItemIcon, Switch } from '@mui/material';
import { Logout, Settings } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getMessages, getOrganization, getUserInfo } from 'redux/reducers/user/selectors';
import { TMessagesRow } from 'redux/reducers/user/types';
import { divide } from 'lodash';
import { TUserMenuProps } from './types';

export const MessagesMenu: FC<TUserMenuProps> = ({ anchorEl, handleCloseMenu }) => {
	const messages = useSelector(getMessages);

	const [showUnread, setShowUnread] = useState(false);
	const handleChangeShowUnread = (event: ChangeEvent<HTMLInputElement>) => {
		setShowUnread(event.target.checked);
	};

	return (
		<Menu
			sx={{ mt: '45px', overflowY: 'auto' }}
			id="menu-appbar"
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={Boolean(anchorEl)}
			onClose={handleCloseMenu}
		>
			<Box
				sx={{
					p: '6px 16px 6px 51px',
					width: '600px',
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
				}}
			>
				<Typography textAlign="left" variant="h5" component="h5" color="primary">
					Messages
				</Typography>
				<FormControlLabel
					control={<Switch value={showUnread} onChange={handleChangeShowUnread} />}
					label="show unread messages only"
					labelPlacement="start"
				/>
			</Box>
			{messages?.rows
				?.filter((item) => {
					if (showUnread) {
						return item.is_read === false;
					}
					return true;
				})
				.map((message: TMessagesRow) => (
					<>
						<MenuItem>
							{message.attachment ? (
								<ListItemIcon>
									<AttachFileIcon />
								</ListItemIcon>
							) : (
								<div style={{ width: '36px' }} />
							)}

							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'start',
									alignItems: 'start',
								}}
							>
								<Typography
									textAlign="left"
									sx={{ fontWeight: message.is_read ? 300 : 900 }}
									color="text.secondary"
									variant="body2"
								>
									{new Date(message.date).toLocaleDateString()}{' '}
									{new Date(message.date).toLocaleTimeString()}
								</Typography>
								<Typography textAlign="left" sx={{ fontWeight: message.is_read ? 300 : 900 }}>
									{message.message_type}
								</Typography>
								<Typography
									textAlign="left"
									sx={{
										fontWeight: message.is_read ? 300 : 900,
										width: '600px',
										// wordWrap: 'break-word',
										// hyphens: 'auto',
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
									variant="body2"
								>
									{message.message}
								</Typography>
							</Box>
						</MenuItem>
						<Divider variant="middle" />
					</>
				))}
		</Menu>
	);
};
